export * from './attr-list/attr-list.component';
